export const VISIT_PATH = 'VISIT_PATH'
export const visitPath = (path) => ({
  type: VISIT_PATH,
  payload: path,
})

export const SAVE_IMAGE = 'SAVE_IMAGE'
export const saveImage = (name, image) => ({
  type: SAVE_IMAGE,
  payload: { name, image },
})

export const SET_LOADING_STATUS = 'SET_LOADING_STATUS'

export const setLoadingStatus = (status) => ({
  type: SET_LOADING_STATUS,
  payload: status,
})

export const SET_ADDING_INVEST_QUESTION_NONILP_NEED_STATUS = 'SET_ADDING_INVEST_QUESTION_NONILP_NEED_STATUS'
export const setAddingInvestmentQuestionForNonILPNeedType = (status) => ({
  type: SET_ADDING_INVEST_QUESTION_NONILP_NEED_STATUS,
  payload: status,
})

export const SET_ACCEPT_ILP_SALE_SHEET = 'SET_ACCEPT_ILP_SALE_SHEET'
export const setAcceptIlpSaleSheet = () => ({
  type: SET_ACCEPT_ILP_SALE_SHEET,
})

export const CLEAR_ACCEPT_ILP_SALE_SHEET = 'CLEAR_ACCEPT_ILP_SALE_SHEET'
export const clearAcceptIlpSaleSheet = () => ({
  type: CLEAR_ACCEPT_ILP_SALE_SHEET,
})
